import state from './moduleApplicationState.js'
import mutations from './moduleApplicationMutations.js'
import actions from './moduleApplicationActions.js'
import getters from './moduleApplicationGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
